import { last } from 'lodash';

// We can cast this to a string, because the call to `split` always returns at least one element
export const mostSignificant = (urn: string) => last(urn.split(':')) as string;
